function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Energie/-Energiebesparing-warmte",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-%-dit-jaar",
  transform: "translate(1.166400, 1.201600)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,11.9984 L24,1.1984 C23.9982002,0.805483801 23.8044104,0.438268805 23.4810562,0.215045975 C23.157702,-0.00817685423 22.7456371,-0.059204714 22.3776,0.0784 L9.1776,6.9104 C8.71117388,7.08629549 8.40178805,7.53191293 8.4,8.0304 L8.4,14.3984",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.4,
  y1: 7.1984,
  x2: 24,
  y2: 7.1984,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18,
  y1: 11.9984,
  x2: 24,
  y2: 11.9984,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 19.1984,
  x2: 3.6,
  y2: 19.1984,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 23.9984,
  x2: 6,
  y2: 23.9984,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 5.448,
  x2: 12,
  y2: 0,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,35.9984 L12,16.7984 C12,15.4729166 10.9254834,14.3984 9.6,14.3984 L2.4,14.3984 C1.0745166,14.3984 0,15.4729166 0,16.7984 L0,35.9984 L14.4,35.9984",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.6219568,15.7984 C25.5976649,15.7984 26.4810027,16.1938838 27.1204136,16.8332947 C27.7598245,17.4727056 28.1553083,18.3560435 28.1553083,19.3317515 L28.1553083,19.3317515 L28.1553083,28.7668279 C28.9634989,29.6422782 29.4194088,30.7936901 29.421987,31.9970851 C29.4235547,33.0979527 29.0501009,34.1285937 28.4092806,34.9508688 C27.7684603,35.7731437 26.8602735,36.3870528 25.7923752,36.6544566 C24.7244765,36.9218606 23.6341502,36.8083829 22.6814472,36.3851288 C21.7287443,35.9618746 20.9136647,35.228844 20.3962593,34.2571422 C19.878854,33.2854404 19.7256381,32.199985 19.9062667,31.1732619 C20.0611862,30.2926731 20.4616806,29.4552877 21.0886052,28.7699267 L21.0886052,28.7699267 L21.0886052,19.3317515 C21.0886052,18.3560435 21.4840891,17.4727056 22.1234999,16.8332947 C22.7629108,16.1938838 23.6462487,15.7984 24.6219568,15.7984 Z",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.6219568,
  y1: 19.3317515,
  x2: 24.6219568,
  y2: 30.7318334,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 32.5572919,
  y1: 23.7651167,
  x2: 34.5839731,
  y2: 23.7651167,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 32.5572919,
  y1: 18.4898008,
  x2: 34.5839731,
  y2: 18.4898008,
  id: "Path",
  stroke: "#425CD4"
})));
function SvgEnergiebesparingwarmte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "40px",
    viewBox: "0 0 36 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Energie/ Energiebesparing warmte") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiebesparingwarmte);
export default __webpack_public_path__ + "static/media/Energiebesparing warmte.44b8e29f42e7855edb6ebd927f75ff2a.svg";
export { ForwardRef as ReactComponent };